export default __webpack_public_path__ + "static/media/StatusNurse.b3ca3531.svg";